import React from "react";

const DoorOpenStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.2 2.39999L12.4046 2.45259C12.8446 2.45511 13.2 2.81254 13.2 3.25258V11.6C13.2 12.0418 12.8418 12.4 12.4 12.4H9.2M3.2 2.39999L9.2 4.85714V14L3.2 11.5429V2.39999Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DoorOpenStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;